<template>
    <div class="d-flex flex-column default-text-font" style="height: 100%">        
        <div class="d-flex flex-column flex-grow-1 collapse-main-base-scv overflow-auto" style="height: 0px;">
            <div>
                <AlertSettingItem alertSettingName="利用許可／禁止アプリケーション"
                                  targetDialog="appMgrSetting"
                                  :requiredSetting="1">
                </AlertSettingItem>
                <div id="collapseappMgrSetting" class="collapse collapse-main-area-scv">
                    <div class="d-flex flex-row flex-grow-1 align-items-center" style="margin-left: 16px;">
                        <div style="min-width:80px">設定方法：</div>
                        <ul class="nav nav-pills" style="row-gap: 8px;">
                            <li class="nav-item-scv nav-item">
                                <a href="#whiteList" class="nav-link-scv nav-link active" data-bs-toggle="tab" @click="openWhiteListApp">
                                    <div class="d-flex align-items-center" style="text-align: left; width: 360px; height:48px;">
                                        <img v-show="!isBlackActive" src="../../../assets/img/skysea_listw_sel.svg" height="32">
                                        <img v-show="isBlackActive" src="../../../assets/img/skysea_listw.svg" height="32">
                                        <div style="width: 8px;"></div>
                                        利用を許可するアプリケーションを設定<br />（ホワイトリスト方式）
                                    </div>
                                </a>
                            </li>
                            <li class="nav-item-scv nav-item">
                                <a href="#blackList" class="nav-link-scv nav-link" data-bs-toggle="tab" @click="openBlackListApp">
                                    <div class="d-flex align-items-center" style="text-align: left; width: 360px; height:48px;">
                                        <img v-show="isBlackActive" src="../../../assets/img/skysea_listb_sel.svg" height="32">
                                        <img v-show="!isBlackActive" src="../../../assets/img/skysea_listb.svg" height="32">
                                        <div style="width: 8px;"></div>
                                        利用を禁止するアプリケーションを設定<br />（ブラックリスト方式）
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div style="height:16px"></div>
                    <div class="scv-separator-bg"></div>
                    <div style="height:16px"></div>

                    <div class="d-flex flex-column flex-grow-1 tab-content">
                        <div id="whiteList" class="tab-pane show-tab-content-flex-grow">
                            <div class="d-flex" style="margin: 0px 0px 12px 16px;">
                                利用を許可するアプリケーションや、自動でインストールするアプリケーションを登録してください。
                            </div>
                            <AppMgrWhiteListSettingForAndroid ref="whiteList"
                                                              :getURLFunction="getURLFunction"
                                                              :getAppFunction="getAppFunction" 
                                                              @onNotifyUpdate="onNotifyUpdate"
                                                              :getUntrustedAppsPolicyFunction="untrustedAppsPolicy"
                                                              :isCheckMobileAndroid="isCheckMobileAndroid"/>
                        </div>

                        <div id="blackList" class="tab-pane">
                            <AppMgrBlackListSettingForAndroid ref="blackList"
                                                              :getURLFunction="getURLFunction"
                                                              :getAppFunction="getAppFunction" 
                                                               @notifyUpdate="onNotifyUpdate" 
                                                              :getUntrustedAppsPolicyFunction="untrustedAppsPolicy"
                                                              :isCheckMobileAndroid ="isCheckMobileAndroid"/>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <AlertSettingItem alertSettingName="アプリケーションのインストール設定"
                                  targetDialog="appMgrSettingInstalled"
                                  :requiredSetting="1" />
                <div id="collapseappMgrSettingInstalled" class="collapse collapse-main-area-scv">
                    <AppMgrSettingInstalledForAndroid ref="appMgrSettingInstalled" @notifyUpdate="onNotifyUpdate" :isCheckMobileAndroid ="isCheckMobileAndroid"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Options, Vue } from "vue-class-component";
    import AppMgrBlackListSettingForAndroid from "@/views/Mobile/AndroidAppDist/AppMgrBlackListSettingForAndroid.vue"
    import AppMgrWhiteListSettingForAndroid from "@/views/Mobile/AndroidAppDist/AppMgrWhiteListSettingForAndroid.vue"
    import { AndroidPolicyWrapper, AndroidPolicyJson, AndroidSkyPolicyJson } from '@/models/Mobile/Android/AndroidPolicyWrapper'
    import * as schema from '@/models/Mobile/Android/AndroidManagementV1Schema'
    import AppMgrSettingInstalledForAndroid from "@/views/Mobile/AndroidAppDist/AppMgrSettingInstalledForAndroid.vue"
    import AlertSettingItem from '@/components/Alert/AlertSettingItem.vue';
    import { BootstrapUtil } from 'lib-vue-v2/util';

    @Options({
        props: {
            getURLFunction: { type: Function },     // Google Play を iframe に埋め込むためのURL取得関数
            getAppFunction: { type: Function },  // アプリケーション詳細情報の取得関数
            isCheckMobileAndroid: { type: Boolean, default: true }, // AndroidライセンスがONかどうか（オンプレ版のことを考えてデフォルトtrue）
        },
        components: {
            AppMgrBlackListSettingForAndroid,
            AppMgrWhiteListSettingForAndroid,
            AppMgrSettingInstalledForAndroid,
            AlertSettingItem
        },
        emits: ['onNotifyUpdate'],
    })

    export default class ApplicationMgrCommonForAndroid extends Vue {
        // 定数
        private readonly BLOCK_LIST_MODE = "BLACKLIST";
        private readonly WHITE_LIST_MODE = "WHITELIST";

        private isBlackActive = false;
            
        /**
         *  アプリ管理設定JSON文字列をセット
         *  @param[in] 
         *  jsonTextList : 
         *  0 : "policy: {...}"
         *  1 : "skyPolicy: {...}"
         */
        public setAppPolicyJsonText(jsonTextList: string[]): void {
            let policyWrapper = new AndroidPolicyWrapper();
            if (0 < jsonTextList.length && 0 < jsonTextList[0].length) {
                policyWrapper = Object.assign(policyWrapper, JSON.parse(jsonTextList[0]));
            }
            if (1 < jsonTextList.length && 0 < jsonTextList[1].length) {
                policyWrapper = Object.assign(policyWrapper, JSON.parse(jsonTextList[1]));
            }

            const refObj: any = this.$refs;

            // アプリ管理情報
            if (null == policyWrapper.policy.playStoreMode
                || this.WHITE_LIST_MODE == policyWrapper.policy.playStoreMode) {
                // ホワイトリスト
                this.openWhiteListApp();
                BootstrapUtil.showTabByQuerySelector('.nav-pills a[href="#whiteList"]');

                refObj.blackList.InitData(policyWrapper);
                refObj.whiteList.LoadUIData(policyWrapper);
            }
            else {
                // ブラックリスト（知らない定数はこっち）
                this.openBlackListApp();
                BootstrapUtil.showTabByQuerySelector('.nav-pills a[href="#blackList"]');

                refObj.blackList.LoadUIData(policyWrapper);
                refObj.whiteList.InitData(policyWrapper);
            }
            
            // インストール設定
            refObj.appMgrSettingInstalled.LoadUIData(policyWrapper);
        }

        private untrustedAppsPolicy():boolean{
            /* eslint @typescript-eslint/no-explicit-any: 0 */
            const refObj: any = this.$refs;
            if(!refObj.appMgrSettingInstalled)return false;
            return refObj.appMgrSettingInstalled.getUntrustedAppsPolicy();
        }

        /**
         * @brief	ブラックリストを開く
         */
        private openBlackListApp(): void {
            const blackList = document.getElementById('blackList');
            const whiteList = document.getElementById('whiteList');
            if (null == blackList || null == whiteList) return;
            blackList.classList.add("show-tab-content-flex-grow");
            whiteList.classList.remove("show-tab-content-flex-grow");

            this.isBlackActive = true;
        }

        /**
         * @brief	ホワイトリストを開く
         */
        private openWhiteListApp(): void {
            const blackList = document.getElementById('blackList');
            const whiteList = document.getElementById('whiteList');
            if (null == blackList || null == whiteList) return;
            blackList.classList.remove("show-tab-content-flex-grow");
            whiteList.classList.add("show-tab-content-flex-grow");

            this.isBlackActive = false;
        }

        /**
         * @brief	UIデータをJson形式で返す
         * @returns
         *  0 : "policy: {...}"
         *  1 : "skyPolicy: {...}"
         */
        public getAppPolicyJsonText(): string[] {
            const arResult = new Array<string>();

            const editPolicy = new AndroidPolicyWrapper();

            /* eslint @typescript-eslint/no-explicit-any: 0 */
            const refObj: any = this.$refs;

            // アプリケーション管理情報
            // ホワイトリストが選択されているかどうか
            const whiteList = document.getElementById('whiteList');
            if (null == whiteList) {
                // ありえない
                return arResult;
            }

            editPolicy.policy.playStoreMode = "";
            if (whiteList.classList.contains("show-tab-content-flex-grow")) {
                // ホワイトリスト
                editPolicy.policy.playStoreMode = this.WHITE_LIST_MODE;

                // ホワイトリストから吸い上げる
                refObj.whiteList.SaveUIData(editPolicy);
            }
            else {
                // ブラックリスト
                editPolicy.policy.playStoreMode = this.BLOCK_LIST_MODE;

                // ブラックリストから吸い上げる
                refObj.blackList.SaveUIData(editPolicy);
            }

            // インストール設定
            refObj.appMgrSettingInstalled.SaveUIData(editPolicy);

            // Jsonにするため、一度コピーが必要。。。
            const policy = new AndroidPolicyJson();
            policy.policy = editPolicy.policy;

            const skyPolicy = new AndroidSkyPolicyJson();
            skyPolicy.skypolicy = editPolicy.skypolicy;

            arResult.push(JSON.stringify(policy));
            arResult.push(JSON.stringify(skyPolicy));

            return arResult;
        }

        /**
         * 更新通知
         */
        private onNotifyUpdate(): void {
            this.$emit("onNotifyUpdate");
        }
    }
</script>

<style>
    /* アプリケーション管理部分のCSSはオンプレ版と共通を使用する */
    @import "../../../assets/css/MobileAndroidCommon.css";
</style>